import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Text_Alignment = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">📐 CSS Text Alignment</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        The <code>text-align</code> property in CSS is used to set the
        horizontal alignment of text inside a block element. It can align text
        to the <strong>left</strong>, <strong>right</strong>,{" "}
        <strong>center</strong>, or <strong>justify</strong>.
      </p>

      {/* Left Align */}
      <div className="tutorial-section">
        <h2 className="section-title">Left Alignment (Default)</h2>
        <p>Text is aligned to the left edge by default.</p>
        <CodeCopyBlock
          code={`p {
  text-align: left;
}`}
        />
        <p
          style={{
            textAlign: "left",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          This text is aligned to the left.
        </p>
      </div>

      {/* Right Align */}
      <div className="tutorial-section">
        <h2 className="section-title">Right Alignment</h2>
        <p>Text is aligned to the right edge of its container.</p>
        <CodeCopyBlock
          code={`p {
  text-align: right;
}`}
        />
        <p
          style={{
            textAlign: "right",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          This text is aligned to the right.
        </p>
      </div>

      {/* Center Align */}
      <div className="tutorial-section">
        <h2 className="section-title">Center Alignment</h2>
        <p>Centers the text horizontally inside its container.</p>
        <CodeCopyBlock
          code={`p {
  text-align: center;
}`}
        />
        <p
          style={{
            textAlign: "center",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          This text is aligned to the center.
        </p>
      </div>

      {/* Justify */}
      <div className="tutorial-section">
        <h2 className="section-title">Justify Alignment</h2>
        <p>
          Makes the text spread evenly across the width of the container, so
          both left and right edges are aligned.
        </p>
        <CodeCopyBlock
          code={`p {
  text-align: justify;
}`}
        />
        <p
          style={{
            textAlign: "justify",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          This is an example of justified text. It adjusts the spacing between
          words so that both the left and right edges of the text block are
          aligned, making it look neat like in newspapers or books.
        </p>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">Next Steps</h2>
        <p>
          After mastering text alignment, you can explore{" "}
          <a href="/css/text-decoration" className="learn-more">
            CSS Text Decoration
          </a>{" "}
          to learn how to add underlines, overlines, and more styles to your
          text.
        </p>
      </div>
    </div>
  );
};

export default Text_Alignment;
